import { regex } from 'react-admin';

export const taxNumberUA =
    (message = 'РНОКПП має містити 10 цифр') =>
    (value: string) => {
        if (!value || value.trim() === '') {
            return undefined; // No validation error for empty value (field is optional)
        }
        const regexValidator = regex(/^\d{10}$/, message);
        return regexValidator(value);
    };

export const minArrayLength =
    (minLength: number, message = `Array must contain at least ${minLength} items."`) =>
    (value: any[]) => {
        if (Array.isArray(value)) {
            return value.length >= minLength ? undefined : message;
        }
        return message;
    };
